<h3 translate class="page-title text-center">SAVED_CARTS</h3>
<lib-filter-list #productList [configService]="savedCartConfigService"></lib-filter-list>
